import React, {useState} from 'react';
import BtnWhite from '../../../Shared/Buttons/BtnWhite';
import {connect} from 'react-redux';
import BtnSubmit from 'app/Components/Shared/Buttons/BtnSubmit';
import {ChangeClientName, AddOrRemoveImeiAction} from '../../PortalsBlock/portalSlice';
import {blockTransferBusinessCustomer, getEntityDetailsInfo} from '../../TransferOrganizationAccountBlock/TransferOrganizationAccountSlice';
import PopUp from '../../../Shared/Popup/PopUp';
import SimActionsPopUp from './SimActionsPopUp';
import {showAppLoader, hideAppLoader} from '../../../Shared/Loader/LoaderSlice';
import {selfServiceDwh} from '../../../../utilities/SelfServiceDwh';
const SimActionBtns = (props) => {
  const [activeBtn, setActiveBtn] = useState(null);
  const [newClientName, setNewClientName] = useState({firstName: '', lastName: ''});
  const [newIMEI, setNewIMEI] = useState('');
  const [showResultPopUp, setShowResultPopUp] = useState(false);
  const [popUpData, setPopUpData] = useState({type: 'error', message: 'מצטערים, משהו השתבש ולא ניתן לבצע את הפעולה שביקשת'});
  const [IMEIChangesCounter, setIMEIChangesCounter] = useState(0);
  const [isNumberActivated, setIsNumberActivated] = useState(false);
  const [error, setError] = useState({
    firstName: false,
    lastName: false,
    imei: false,
  });

  
  const subscriber = props?.transferOrgState?.selectedTransferOption === 'niud'
        ? props?.transferOrgState?.tempNiudNumber
        : props?.transferOrgState?.selectedPhoneNumber;

  const handleChangeName = async () => {
    setError({firstName: false, lastName: false});

    const nameRegex = /^[a-zA-Z\u0590-\u05FF\s]+$/;
    const firstNameValid = nameRegex.test(newClientName.firstName);
    const lastNameValid = nameRegex.test(newClientName.lastName);

    if (!firstNameValid || !lastNameValid) {
      setError({firstName: !firstNameValid, lastName: !lastNameValid});
      return;
    }
    if (!isNumberActivated) {
      const isNumberReady = await checkForActivation();
      if (!isNumberReady) return;
    }
    const res = await props.ChangeClientName({
      orgId: props?.portalState?.selectedHetPayId,
      selectedNumber: subscriber,
      newFirstName: newClientName.firstName,
      newLastName: newClientName.lastName,
    });

    const success = res?.payload?.isSuccess;
    if (success) {
      selfServiceDwh.TransferOrganizationAccount.UpdateClientName({name: newClientName.firstName + ' ' + newClientName.lastName, _subscriber: subscriber});
    }
    setPopUpData({
      type: success ? 'success' : 'error',
      message: success ? 'עדכון שם מנוי בוצע בהצלחה!' : 'מצטערים, משהו השתבש ולא ניתן לבצע את הפעולה שביקשת',
    });

    setShowResultPopUp(true);
    setNewClientName({firstName: '', lastName: ''});
  };

  const handleAddIMEI = async () => {
    setError({imei: false});
    
    const imeiValid = /^[0-9]{15}$/.test(newIMEI);
    
    if (!imeiValid) {
      setError({imei: true});
      return;
    }
    if (!isNumberActivated) {
      const isNumberReady = await checkForActivation();
      if (!isNumberReady) return;
    }
    props.showAppLoader();
    if (IMEIChangesCounter >= 3) {
      setPopUpData({
        type: 'error',
        message: 'מצטערים, משהו השתבש ולא ניתן לבצע את הפעולה שביקשת.',
      });
      props.hideAppLoader();
      setShowResultPopUp(true);
      return;
    }

    let res = await props.AddOrRemoveImeiAction({
      selectedNumber:   subscriber,
      selectedImei: newIMEI,
      action: true,
      isSecondRound: false,
      orgId: props?.portalState?.selectedHetPayId,
    });
    
    if (res?.payload?.isCheckSuccess) {
      selfServiceDwh.TransferOrganizationAccount.AddIMEI({imei: newIMEI, _subscriber: subscriber});
      setIMEIChangesCounter(IMEIChangesCounter + 1);
    }
    setPopUpData({
      type: res?.payload?.isAddSuccess ? 'success' : 'error',
      message: res?.payload?.isAddSuccess ? 'הוספת IMEI בוצע בהצלחה!' : 'מצטערים, משהו השתבש ולא ניתן לבצע את הפעולה שביקשת',
    });
    props.hideAppLoader();
    setShowResultPopUp(true);
    setNewIMEI('');
  };

  const handleBlockTransfer = async () => { 
    if (!isNumberActivated) {
      const isNumberReady = await checkForActivation();
      if (!isNumberReady) return;
    }
    try {
      let res = await props.blockTransferBusinessCustomer();
      if (res?.payload?.isSuccess) {
        setPopUpData({type: 'success', message: 'חסימה בוצעה בהצלחה!'});
        selfServiceDwh.TransferOrganizationAccount.BlockTransfer({_subscriber: subscriber}); 
      } else {
        setPopUpData({type: 'error', message: 'מצטערים, משהו השתבש ולא ניתן לבצע את הפעולה שביקשת'});
      }
    } catch (error) {
      setPopUpData({type: 'error', message: 'מצטערים, משהו השתבש ולא ניתן לבצע את הפעולה שביקשת'});
    }
    setShowResultPopUp(true);
  };

  const handleActiveBtn = (btn) => {
    if (activeBtn === btn) {
      setActiveBtn(null);
    } else {
      setActiveBtn(btn);
    }
  };

  const checkForActivation = async () => {
    props.showAppLoader();
    return new Promise((resolve) => {
      setTimeout(async () => {
        try {
          const isNumberReady = await props.getEntityDetailsInfo();
          if (!isNumberReady.payload) {
            setPopUpData({type: 'error', message: 'לקוח יקר, ברגעים אלה אנו מקימים את הקו במערכת, אנא נסה שוב בעוד מספר שניות'});
            setShowResultPopUp(true);
            resolve(false);
          } else {
            setIsNumberActivated(true);
            resolve(true);
          }
        } catch (error) {
          resolve(false);
        } finally {
          props.hideAppLoader();
        }
      }, 5000);
    });
  };

  return (
    <div className='sim-action-btns'>
      <span className={'actions-title'}>עוד פעולות בקליק!</span>
      <div>
        <BtnWhite
          text='עדכון שם מנוי'
          onclick={() => handleActiveBtn('updateName')}
          className={activeBtn === 'updateName' ? 'active' : ''}></BtnWhite>
        {activeBtn === 'updateName' && (
          <div className='open-field-box'>
            <input
              placeholder='שם פרטי'
              value={newClientName?.firstName}
              required={true}
              onChange={(x) => {
                setNewClientName({
                  ...newClientName,
                  firstName: x.target.value,
                });
              }}
            />
            <span className='error'>{error.firstName ? 'שם פרטי חייב להכיל אותיות בלבד' : ''}</span>
            <input
              placeholder='שם משפחה'
              value={newClientName?.lastName}
              required={true}
              onChange={(x) => {
                setNewClientName({
                  ...newClientName,
                  lastName: x.target.value,
                });
              }}
              error={error.lastName ? 'שם משפחה חייב להכיל אותיות בלבד' : ''}
            />
            {error.lastName && <span className='error'>שם משפחה חייב להכיל אותיות בלבד</span>}
            <BtnSubmit text='עדכון' onclick={() => handleChangeName()}></BtnSubmit>
          </div>
        )}

        <BtnWhite
          text='הוספת IMEI'
          onclick={() => handleActiveBtn('addIMEI')}
          className={activeBtn === 'addIMEI' ? 'active' : ''}></BtnWhite>
        {activeBtn === 'addIMEI' && (
          <div className='open-field-box'>
            <input
              placeholder='הזנת מספר IMEI'
              value={newIMEI}
              required={true}
              maxLength={15}
              onChange={(x) => {
                setNewIMEI(x.target.value);
              }}
            />
            {error.imei && <span className='error'>מספר IMEI חייב להכיל 15 ספרות</span>}
            <BtnSubmit text='להוספה' onclick={() => handleAddIMEI()}></BtnSubmit>
          </div>
        )}
      </div>

      <BtnWhite
        text='חסימה לניוד'
        onclick={() => handleActiveBtn('blockTransfer')}
        className={activeBtn === 'blockTransfer' ? 'active' : ''}></BtnWhite>
      {activeBtn === 'blockTransfer' && (
        <div className='open-field-box'>
          <BtnSubmit text='לאישור החסימה' onclick={() => handleBlockTransfer()}></BtnSubmit>
        </div>
      )}
      <PopUp showPopUp={showResultPopUp} onClose={() => setShowResultPopUp(false)}>
        <SimActionsPopUp popUpData={popUpData} onClose={() => setShowResultPopUp(false)}></SimActionsPopUp>
      </PopUp>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    portalState: state.portalsBlock,
    transferOrgState: state.TransferOrganizationAccount,
  };
};

const mapDispatchToProps = {
  ChangeClientName,
  AddOrRemoveImeiAction,
  blockTransferBusinessCustomer,
  showAppLoader,
  hideAppLoader,
  getEntityDetailsInfo,
};

export default connect(mapStateToProps, mapDispatchToProps)(SimActionBtns);
